module.exports = __webpack_public_path__ + "static/img/wdzt1-1.fc892e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzt1-1.png
// module id = 848
// module chunks = 0